const neutrals = {
    100: '#f8f9f9',
    200: '#f4f5f5',
    300: '#e1e1e2',
    400: '#c2c2c2',
    500: '#999999',
    600: '#666666',
};
export default neutrals;
//# sourceMappingURL=neutrals.js.map